import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "app/App Store/state";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue = "";
  isFilter: boolean = false;
  public columns = [
    { name: "Name", prop: "displayname" },
    { name: "Type", prop: "type" },
    { name: "References", prop: "references" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = [];

  imageUrl = environment.apiUrls.imageUrl;

  assets_id: any;
  searchVal: any;
  @ViewChild("name") inputName;
  user_role: any;

  guideline_data: any;
  update_password: any;
  read_password: any;
  gig_tags_list = []
  selected_gig_tag = null
  type_list = [
    { name: "Portfolio", id: "portfolio" },
    { name: "Product", id: "product" },
    { name: "Project Analysis Document", id: "pad" },
    { name: "Topic Analysis Document", id: "tad" },
    { name: "Portfolio Feature Document", id: "pfd" },
    { name: "Bundle Feature Document", id: "bfd" },
    { name: "Research", id: "research" },
    { name:"Gigs", id:"gigs"}
  ];
  selected_type = null;
   skillId = "6319d3595ab9e462a96cfb06";
  skills_tag_List = [];
  selected_skill = null;
  current_data: any
  skills_keywords_List = [];
  features_keywords_List = [];
  projects_keywords_List = [];
  selected_skills_keywords = null
  selected_features_keywords = null
  selected_projects_keywords = null
  isCollapsedSkills = false;
  isCollapsedFeatures = false;
  isCollapsedProjects = false;
  modal_prop:any
  update_prop: any
  updated_data: any
  isUpdateName: boolean = false
  isUpdateNotes: boolean = false
  isUpdateAdminNotes: boolean = false
  isUpdateSkills: boolean = false
  isUpdateFeatures : boolean = false
  isUpdateProjects : boolean = false
  isAddSkillKeyword: boolean = false
  isAddfeaturesKeyword: boolean = false
  isAddProjectsKeyword: boolean = false
  skill_keywords:any = []
  features_keywords:any  = []
  projects_keywords:any  = []
  empType: any = []
  domain_list = []
  selected_domain = null
  pageNumberSubscription : Subscription
  current_row:any
  constructor(
    public apiService: ApiService,
    private router: Router,
    private modalService: NgbModal,
    public toastr: ToastrService,
    private spinner: NgxSpinnerService,private store: Store<AppState>,private route: ActivatedRoute
  ) {
    this.user_role = JSON.parse(localStorage.getItem("user"));
    if (this.user_role.roles !== "admin") {
      this.empType = JSON.parse(localStorage.getItem("empType"));
      this.empType = this.empType.map(item =>item.displayname)
    }
    let setting_data = JSON.parse(localStorage.getItem("setting-record"));
    let key_data = setting_data.filter((item) => item.key == "Digital Assets");
    this.guideline_data = key_data[0]?._id;

    this.route.queryParamMap.subscribe((params) => {
      let search = params.get('search');
      if(search) {
        this.searchVal =search
        this.filterAssets(search,'','','')
      }
      let page = +params.get('page');
      this.setPage(page)
    });
    this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
    .subscribe(pageNumber => {
      this.page.pageNumber = pageNumber;
      if(pageNumber !==undefined){
        this.page.pageNumber = pageNumber -1
      }
      if(pageNumber === 0) this.page.pageNumber = 0
      
    });
  }

  ngOnInit(): void {
    this.getAllCategory()
    this.getSkillTagByCategory()
    this.getAllAssets();
    this.getAllSettings();
  }
setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getAllSettings() {
    this.apiService.getAllSetting(1, 100).subscribe((res: any) => {
      let update_password = res?.items?.filter(
        (item) => item.key == "update_assets_password"
      );
      this.update_password = update_password[0]?.value;
      let read_password = res?.items?.filter(
        (item) => item.key == "read_assets_password"
      );
      this.read_password = read_password[0]?.value;
    });
  }
  getAllAssets() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService
      .filterAssets(this.page.pageNumber +1 ,this.limitRef,this.searchVal || '', this.selected_type || "",this.selected_gig_tag || "",this.selected_domain || "")
      .subscribe((res: any) => {
        this.spinner.hide();
        this.rows = res.data.items;
        this.page.totalPages = res.data.totalCount;
      });
  }
  pageChangeData(page: any) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
   
      this.apiService
      .filterAssets(page.offset +1 ,this.limitRef,this.searchVal || '', this.selected_type || "",this.selected_gig_tag || "",this.selected_domain || "")
      .subscribe((res: any) => {
        this.spinner.hide()
        this.rows = res.data.items;
        this.page.totalPages = res.data.totalCount;
      });
    // }
    // else {
    //   this.apiService
    //     .getAssetsList(page.offset + 1, page.pageSize)
    //     .subscribe((res: any) => {
    //       this.spinner.hide()
    //       this.rows = res.data.items;
    //       this.page.totalPages = res.data.totalCount;
    //     });
      
    // }
  }
  filterAssets(search: any, type: any,category:any,domain:any) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    type = this.selected_type
    category = this.selected_gig_tag
    domain = this.selected_domain
    this.apiService
      .filterAssets(this.page.pageNumber + 1,this.limitRef,search, type || "",category || "",domain || "")
      .subscribe((res: any) => {
          this.spinner.hide()
          this.rows = res?.data?.items;
          this.page.totalPages = res?.data?.totalCount;
      });
  }
  resetFilter() {
    this.inputName.nativeElement.value = "";
    this.searchVal =''
    this.getAllAssets();
  }

  delete(password) {
    if (password) {
      this.apiService
        .deleteAssets(this.assets_id, password)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.getAllAssets();
            swal.fire({
              title: "Success",
              text: "Student deleted successfully !",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          } else {
            swal.fire({
              title: "Cancelled",
              text: `${res.error}`,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        });
    } else {
      this.toastr.error("Something went wrong !");
    }
  }

  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.assets_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.delete(result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }

  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  confirmUpdate(id: any, prop, content) {
    const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format
    const storedDate = localStorage.getItem('passwordPromptDate');
    const passwordEntered = localStorage.getItem('passwordEntered');

    if (storedDate === today && passwordEntered === 'true' && content) {
      // Password has already been entered today, skip the prompt
      if (prop == "view") this.goToDetailPage(id, null, content);
    }
    else {
      swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          localStorage.setItem('passwordPromptDate', today);
          localStorage.setItem('passwordEntered', 'true');
          if (prop == "update" && !content) this.updateAssets(id, result.value);
          if (prop == "view" && content) this.goToDetailPage(id, result.value,content);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
     }
    
  }
  updateAssets(id, password) {
    if (password == this.update_password) {
      this.router.navigate(["assets/edit", id]);
    } else {
      swal.fire({
        title: "Error",
        text: "Incorrect Password!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
  goToDetailPage(data, password,content) {
    if (content) {
      this.current_data = data
      // this.router.navigate(["assets/view", id]);
      const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.current_data =null
      },
      (reason) => {
        this.current_data =null
      }
    );
    } else {
      swal.fire({
        title: "Error",
        text: "Incorrect Password!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
  getAllCategory() {
    this.apiService.getAllCategory(1,100).subscribe((res: any) => {
      let data = res?.data?.items?.filter((item) => item?.name === 'Gig Keyword')
      let skill_keywords = res?.data?.items?.filter((item) => item?.name === 'Skill Keywords')
      let features_keywords = res?.data?.items?.filter((item) => item?.name === 'Features Keywords')
      let projects_keywords = res?.data?.items?.filter((item) => item?.name === 'Projects Keywords')
      let domain_tags = res?.data?.items?.filter((item) => item?.name === 'Domain')
     
      if(data) this.getAllGigTags(data[0]._id)
      if(skill_keywords) this.getAllSkillKeywordsTags(skill_keywords[0]._id)
      if(features_keywords) this.getAllFeaturesKeywordsTags(features_keywords[0]._id)
      if (projects_keywords) this.getAllProjectsKeywordsTags(projects_keywords[0]._id)
      if(domain_tags) this.getAllDomainTags(domain_tags[0]._id)
    })
  }
  getAllGigTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.gig_tags_list = res.data;
    });
  }
  getAllDomainTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.domain_list = res.data;
    });
  }
  getAllSkillKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.skills_keywords_List = res.data;
    });
  }
  getAllFeaturesKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.features_keywords_List = res.data;
    });
  }
  getAllProjectsKeywordsTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.projects_keywords_List = res.data;
    });
  }
  getTypeId(event) {
    this.selected_type
    this.page.pageNumber =0
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: 1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getGigId(event) {
    this.selected_gig_tag
    this.page.pageNumber =0
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: 1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
   getDomainId(event) { 
     this.selected_domain
     this.page.pageNumber =0
     this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: 1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
     this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.skills_tag_List = res.data;
    });
  }
  // getSkillTagsId(event: any) {
  //   this.selected_skill;
  //   this.filterAssets('',this.selected_type,this.selected_gig_tag,selected_skills_keywords,selected_features_keywords,selected_projects_keywords)
  // }
  getSkillKeywordsTagsId(event: any) {
    this.selected_skills_keywords;
    this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getFeaturesKeywordsTagsId(event: any) {
    this.selected_features_keywords;
    this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  getProjectsKeywordsTagsId(event: any) {
    this.selected_projects_keywords;
    this.filterAssets('', this.selected_type || "", this.selected_gig_tag|| "",this.selected_domain ||"")
  }
  goToKeywords(data,prop,content){
    if(prop == 'skill'){
      this.modal_prop = prop
      this.current_data = data
    }
    if(prop == 'feature'){
      this.modal_prop = prop
      this.current_data = data
    }
    if(prop == 'project'){
      this.modal_prop = prop
      this.current_data = data
    }
      // this.router.navigate(["assets/view", id]);
      const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.current_data =null
        this.modal_prop = null
      },
      (reason) => {
        this.current_data =null
        this.modal_prop = null
      });
  }
  updateTags(id,tag_id) {
    
    let body = {
      category: tag_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Tags updated successfully');
        this.getAllAssets();
      }
    });
  }
  updateDomain(id,tag_id) {
    
    let body = {
      domain: tag_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Domain updated successfully');
        this.getAllAssets();
      }
    });
  }
  updateType(id,type_id) {
    let body = {
      type: type_id
    }
    this.apiService.updateAssets(id, body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('Type updated successfully');
        this.getAllAssets();
      }
    });
  }
  editItem(id,data,prop) {
    this.update_prop = prop
    if (this.update_prop == 'name') { 
      this.assets_id = id
      this.isUpdateName = !this.isUpdateName
      this.updated_data = data
    }
    if (this.update_prop == 'notes') { 
      this.assets_id = id
      this.isUpdateNotes = !this.isUpdateNotes
      this.updated_data = data
    }
    if (this.update_prop == 'admin notes') { 
      this.assets_id = id
      this.isUpdateAdminNotes = !this.isUpdateAdminNotes
      this.updated_data = data
    }
    if (this.update_prop == 'skill') { 
      this.assets_id = id
      this.isUpdateSkills = !this.isUpdateSkills
      this.skill_keywords = data
    }
    if (this.update_prop == 'feature') { 
      this.assets_id = id
      this.isUpdateFeatures = !this.isUpdateFeatures
      this.features_keywords = data
    }
    if (this.update_prop == 'project') { 
      this.assets_id = id
      this.isUpdateProjects = !this.isUpdateProjects
      this.projects_keywords = data
    }
  }
  update(prop) {
    if(prop == 'name'){
        let body = {
        name: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateName = false
          this.updated_data = ''
          this.toastr.success('Name updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'notes'){
        let body = {
        notes: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateNotes = false
          this.updated_data = ''
          this.toastr.success('Notes updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'admin notes'){
        let body = {
        admin_notes: this.updated_data
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateAdminNotes = false
          this.updated_data = ''
          this.toastr.success('Admin notes updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'skill'){
        let body = {
           skill_keywords: this.skill_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateSkills = false
          this.isAddSkillKeyword = false
          this.skill_keywords = ''
          this.toastr.success('skills updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'feature'){
        let body = {
           features_keywords: this.features_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateFeatures = false
          this.isAddfeaturesKeyword = false
          this.features_keywords = []
          this.toastr.success('features updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    if(prop == 'project'){
        let body = {
           projects_keywords: this.projects_keywords
      }
      this.apiService.updateAssets(this.assets_id, body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.isUpdateProjects = false
          this.isAddProjectsKeyword = false
          this.projects_keywords = []
          this.toastr.success('projects updated successfully');
          this.modalService.dismissAll()
          this.getAllAssets();
        }
      });
    }
    
    
  }
 
  addKeyword(data: string, prop: string) {
    // Split data by commas, trim whitespace, and filter out empty strings
    const keywords = data?data.split(',')
                          .map(keyword => keyword.trim())
                          .filter(keyword => keyword):[];
    // Use switch to handle different properties
    switch (prop) {
      case "skill":
        if (!Array.isArray(this.skill_keywords)) {
          this.skill_keywords = [];
        }
        let key_word = {name:keywords}
        this.skill_keywords.push(key_word);
        this.update(prop);
        break;
      case "feature":
        if (!Array.isArray(this.features_keywords)) {
          this.features_keywords = [];
        }
        let key_word2 = {name:keywords}
        this.features_keywords.push(key_word2);
        this.update(prop);
        break;
      case "project":
        if (!Array.isArray(this.projects_keywords)) {
          this.projects_keywords = [];
        }
        let key_word3 = {name:keywords}
        this.projects_keywords.push(key_word3);
        this.update(prop);
        break;
      default:
        console.error(`Unknown property: ${prop}`);
        break;
    }
  }
removeKeyword(indx: any, prop: any) {
  switch (prop) {
    case "skill":
      this.skill_keywords.splice(indx, 1)
      break;
    case "feature":
      this.features_keywords.splice(indx, 1)
      break;
    case "project":
      this.projects_keywords.splice(indx, 1)
      break;
  }
}
copyItem(id){
  let url = `https://do.meander.software/digital-assets/${id}`
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = url
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.info('copy digital assets url')
}
openModal(content, data) {
  const options: NgbModalOptions = {
    size: 'lg', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  this.current_row = data
  this.modalService.open(content, options); // open the modal
}

 
}
